import { render, staticRenderFns } from "./EntregaModal.vue?vue&type=template&id=6f635771&scoped=true"
import script from "./EntregaModal.vue?vue&type=script&lang=js"
export * from "./EntregaModal.vue?vue&type=script&lang=js"
import style0 from "./EntregaModal.vue?vue&type=style&index=0&id=6f635771&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f635771",
  null
  
)

export default component.exports